import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useHomeStore } from '../../store/useHomeStore'
import Loader from '../../Components/Loader'

const Projectstatics = () => {
    const navigate = useNavigate()
    let [loading, setLoading] = useState(false)
    let { analytics, postProjectanalytics } = useHomeStore()

    const [data, setData] = useState({
        earthMoved: '',
        concretePoured: '',
        completedProject: '',
        yearOfEstablishment: '',
    });

    const handleSubmit = async () => {
        setLoading(true)
        await postProjectanalytics(data)
        setLoading(false)
    }

    useEffect(() => {
        setData({
            earthMoved: analytics?.earthMoved || '',
            concretePoured: analytics?.concretePoured || '',
            completedProject: analytics?.completedProject || '',
            yearOfEstablishment: analytics?.yearOfEstablishment || '',
        })
    }, [analytics])

    return (
        <div id="banner-section" className="bg-white rounded-md shadow-sm border border-neutral-200 mb-9 overflow-hidden" >
            <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
                <h3>
                    Project Statistics
                </h3>
            </div>
            <Loader loading={loading}>
                <div className="p-6">
                    <div className="grid grid-cols-1 gap-6">
                        <div>
                            <label className="block text-sm text-neutral-700 mb-2">CY of Earth Moved</label>
                            <input
                                type="text"
                                value={data?.earthMoved}
                                onChange={(e) => setData({ ...data, earthMoved: e.target.value })}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />
                            <label className="block text-sm text-neutral-700 mb-2">CY of Concrete Poured</label>
                            <input type="text"
                                value={data?.concretePoured}
                                onChange={(e) => setData({ ...data, concretePoured: e.target.value })}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />
                            <label className="block text-sm text-neutral-700 mb-2">Completed Projects</label>
                            <input type="text"
                                value={data?.completedProject}
                                onChange={(e) => setData({ ...data, completedProject: e.target.value })}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />
                            <label className="block text-sm text-neutral-700 mb-2">Year Established</label>
                            <input type="text"
                                value={data?.yearOfEstablishment}
                                onChange={(e) => setData({ ...data, yearOfEstablishment: e.target.value })}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />

                        </div>
                    </div>
                </div>
            </Loader>
            <div className="flex justify-end space-x-3 p-3">
                <button className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-md"
                    onClick={() => navigate(-1)}
                >Cancel</button>
                <button
                    className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                    onClick={() => handleSubmit()}
                >
                    Save Project Statistics
                </button>
            </div>
        </div>
    )
}

export default Projectstatics
